/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

const routes: Routes = [
  {
    path: 'embed_report_builder',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    data: {
      layout: 'empty',
      app: 'advanced_reports'
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./components/report-builder/report-builder.module').then(m => m.ReportBuilderModule)
      }
    ]
  },
  { path: 'advanced_reports', redirectTo: 'advanced_reports/all', pathMatch: 'full' },
  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./components/report-builder/report-builder.module').then(m => m.ReportBuilderModule)
      }
    ]
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
